let bullmanImageName: bullmanInstanceType;

export enum bullmanInstanceType {
	bullmanV2 = 'bullman-v2',
	recording = 'recording',
	default = 'chrome-rtmp',
}

export const setBullmanImageName = (): void => {
	bullmanImageName = bullmanInstanceType.bullmanV2;
};

export const getBullmanImageName = (): bullmanInstanceType => bullmanImageName;
